import { createActionsGroup } from 'utils/redux-utils'

export const getPromoGroupProductsActions = createActionsGroup(
  'GET_PROMO_GROUP_PRODUCTS',
)
